import { useEffect, useState, type ReactNode } from "react";
import { ContentContext, type ContentState } from "./ContentContext";
import { loadSiteContent } from "./loaders";

export default function ContentProvider({ children }: { children: ReactNode }) {
  const [state, setState] = useState<ContentState>({ content: null, error: null });

  useEffect(() => {
    let active = true;

    loadSiteContent()
      .then((content) => {
        if (active) setState({ content, error: null });
      })
      .catch((error: unknown) => {
        if (!active) return;
        setState({
          content: null,
          error: error instanceof Error ? error.message : "内容加载失败",
        });
      });

    return () => {
      active = false;
    };
  }, []);

  return <ContentContext.Provider value={state}>{children}</ContentContext.Provider>;
}
